<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.service_provider_mangment_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- <h2>
            {{ $t("PLACEHOLDERS.providerData") }}
          </h2> -->

          <!-- Start:: Ar Name Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider_name"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
          /> -->
          <!-- End:: Ar Name Input -->
          <h2>
            {{ $t("PLACEHOLDERS.shopData") }}
          </h2>
          <!-- Start:: En Name Input -->
          <base-image-upload-input
            col="12"
            identifier="logo"
            :preSelectedImage="data.logo.path"
            :placeholder="$t('PLACEHOLDERS.logo')"
            @selectImage="selectImageLogo"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_name')"
            v-model.trim="data.shop_name"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_mobile')"
            v-model.trim="data.shop_mobile"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.commission')"
            v-model.trim="data.commission"
          />

          <base-image-upload-input
            col="12"
            identifier="commercial_register_image"
            :preSelectedImage="data.commercial_register_image.path"
            :placeholder="$t('PLACEHOLDERS.commercial_register_image')"
            @selectImage="selectImageCommercial"
            required
          />

          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc')"
            v-model.trim="data.desc"
          />
          <base-select-input
            :optionsList="sections"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.main_section')"
            v-model.trim="data.mainC"
            @input="getSubSections(), (data.subC = null)"
          />
          <base-select-input
            :optionsList="subSections"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.sub_section')"
            v-model.trim="data.subC"
          />

          <h2>
            {{ $t("PLACEHOLDERS.storeLocation") }}
          </h2>
          <!-- <div class="map_wrapper">
            <GmapMap
              :center="{
                lat: parseFloat(data.lat),
                lng: parseFloat(data.lng),
              }"
              :zoom="13"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="false"
                :draggable="false"
                @click="center = m.position"
              />
            </GmapMap>
          </div> -->
          <!-- Start:: Map Address Input -->
          <div class="map_wrapper mb-3" v-if="data.lat && data.lng">
            <!-- <MapComponent :lat="parseFloat(data.lat)" :lng="parseFloat(data.lng)" /> -->

            <ChangableMapComponent
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
              @update:lat="data.lat = $event"
              @update:lng="data.lng = $event"
            />
          </div>

          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.storeLocation')"
            v-model.trim="data.storeLocation"
          />
          <base-select-input
            :optionsList="states"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.municipality')"
            v-model.trim="data.state"
            @input="getRegions(), (data.region = null), (data.district = null)"
          />
          <base-select-input
            :optionsList="regions"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model.trim="data.region"
            @input="getDistricts(), (data.district = null)"
          />
          <base-select-input
            :optionsList="districts"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district"
          />

          <!-- End:: count_stores Input -->
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import ChangableMapComponent from "../../../components/general/ChangableMapComponent.vue";

export default {
  name: "CreateArea",
  components: {
    UploadsPhotos,
    ChangableMapComponent,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        commercial_register_image: {
          path: null,
          file: null,
        },
        logo: {
          path: null,
          file: null,
        },
        provider_name: null,
        phone: null,
        shop_name: null,
        shop_mobile: null,
        email: null,
        desc: null,
        mainC: null,
        subC: null,
        state: null,
        region: null,
        district: null,
        lat: null,
        lng: null,
        password: null,
        confirmPassword: null,
        district: null,
        storeLocation: null,
        street: null,
        twoer: true,
        vehicle_license_image_face: true,
        vehicle_license_image_back: true,
        work_hours: [],
        commission: null,
      },
      additionalImages: [],
      imgUrls: [],
      markers: [],
      regions: [],
      districts: [],
      states: [],
      sections: [],
      subSections: [],

      // End:: Data Collection To Send
    };
  },

  methods: {
    selectImageLogo(selectedImage) {
      this.data.logo = selectedImage;
    },
    selectImageCommercial(selectedImage) {
      this.data.commercial_register_image = selectedImage;
    },

    getDay(id) {
      if (id == 1) {
        return this.$t("PLACEHOLDERS.1");
      }
      if (id == 2) {
        return this.$t("PLACEHOLDERS.2");
      }
      if (id == 3) {
        return this.$t("PLACEHOLDERS.3");
      }
      if (id == 4) {
        return this.$t("PLACEHOLDERS.4");
      }
      if (id == 5) {
        return this.$t("PLACEHOLDERS.5");
      }
      if (id == 6) {
        return this.$t("PLACEHOLDERS.6");
      }
      if (id == 7) {
        return this.$t("PLACEHOLDERS.7");
      }
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];
      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });
        console.log("provider", res.data.data.Provider);

        // Start:: Set Data
        this.data.provider_name = res.data.data.Provider.name;
        this.data.phone = res.data.data.Provider.mobile;
        this.data.logo.path = res.data.data.Provider.logo_path;
        this.data.shop_name = res.data.data.Provider.store_name;
        this.data.shop_mobile = res.data.data.Provider.store_mobile;
        this.data.email = res.data.data.Provider.email;
        this.data.commercial_register_image.path =
          res.data.data.Provider.commercial_register_path;
        this.data.desc = res.data.data.Provider.description;
        this.data.mainC = res.data.data.Provider.section;
        this.data.subC = res.data.data.Provider.sub_section;
        this.data.state = res.data.data.Provider.state;
        this.data.region = res.data.data.Provider.region;
        this.data.district = res.data.data.Provider.district;
        this.data.storeLocation = res.data.data.Provider.address;
        this.data.lat = res.data.data.Provider.latitude;
        this.data.lng = res.data.data.Provider.longitude;
        this.data.commission = res.data.data.Provider.commission;
        this.markers = [
          {
            id: 1,
            position: {
              lat: parseFloat(res.data.data.Provider.latitude),
              lng: parseFloat(res.data.data.Provider.longitude),
            },
          },
        ];
        // End:: Set Data
        this.getRegions();
        this.getDistricts();
        this.getSubSections();
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    validateFormInputs() {
      this.isWaitingRequest = true;

      //  else if (!this.data.nameEn) {
      //     this.isWaitingRequest = false;
      //     this.$message.error(this.$t("VALIDATION.nameEn"));
      //     return;
      //   } else {
      this.submitForm();
      // return;
      // }
    },
    // End:: validate Form Inputs
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      const is_active = this.data.active ? "1" : "0";

      // Start:: Append Request Data
      REQUEST_DATA.append("store_name", this.data.shop_name);
      REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("store_mobile", this.data.phone);
      REQUEST_DATA.append("description", this.data.desc);
      REQUEST_DATA.append("section_id", this.data.mainC.id);
      REQUEST_DATA.append("sub_section_id", this.data.subC.id);
      REQUEST_DATA.append("state_id", this.data.state.id);
      REQUEST_DATA.append("region_id", this.data.region.id);
      REQUEST_DATA.append("district_id", this.data.district.id);
      REQUEST_DATA.append("address", this.data.storeLocation);
      REQUEST_DATA.append("map_address", this.data.map);
      REQUEST_DATA.append("latitude", this.data.lat);
      REQUEST_DATA.append("longitude", this.data.lng);
      REQUEST_DATA.append("commission", this.data.commission);
      if (this.data.commercial_register_image.file) {
        REQUEST_DATA.append(
          "commercial_register_path",
          this.data.commercial_register_image.file
        );
      }
      if (this.data.logo.file) {
        REQUEST_DATA.append("logo_path", this.data.logo.file);
      }

      // REQUEST_DATA.append("is_active", is_active);
      // REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `providers/update-store/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    async getSections() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `sections`,
          params: {
            limit: 0,
            page: 0,
            is_active: 1,
            is_allowed: 1,
          },
        });
        this.sections = res.data.data?.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getSubSections() {
      try {
        let res = await this.$axios({
          method: "GET",
          params: {
            limit: 0,
            page: 0,
            is_active: 1,
            is_allowed: 1,
            parent: this.data.mainC?.id,
          },
          url: `sections?section_type=branch`,
        });
        this.subSections = res.data.data?.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getStates() {
      try {
        let res = await this.$axios({
          method: "GET",
          params: {
            limit: 0,
            page: 0,
            is_active: 1,
            is_allowed: 1,
          },
          url: `states`,
        });
        this.states = res.data.data?.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          params: {
            limit: 0,
            page: 0,
            is_active: 1,
            is_allowed: 1,
            state: this.data.state?.id,
          },
          url: `regions`,
        });
        this.regions = res.data.data?.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getDistricts() {
      try {
        let res = await this.$axios({
          method: "GET",
          params: {
            limit: 0,
            page: 0,
            is_active: 1,
            state: this.data.state?.id,
            region: this.data.region?.id,
            is_allowed: 1,
          },
          url: `districts`,
        });
        this.districts = res.data.data?.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    this.getStates();
    this.getSections();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
</style>
